import React from 'react';

export const withQueryStringUpdater = (Container, updateUrl: any) => () => <Container updateUrl={updateUrl} />;